import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import React ,{Component} from 'react';
import FormControl from '@mui/material/FormControl';
import Checkbox from '@mui/material/Checkbox';
import {NavLink, Navigate  } from 'react-router-dom';
import axios from 'axios';
import { styled } from '@mui/system';
import IconButton from '@mui/material/IconButton';
import RadioGroup from '@mui/material/RadioGroup';
import Table from '@mui/material/Table';
import Collapse from '@mui/material/Collapse';
import Alert from '@mui/material/Alert';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Select from '@mui/material/Select';
//import { styled } from '@mui/material/styles';
import TableRow from '@mui/material/TableRow'; 
import TableCell from '@mui/material/TableCell';
import Radio, { RadioProps } from '@mui/material/Radio';
import Autocomplete from '@mui/material/Autocomplete';
import FormLabel from '@mui/material/FormLabel';
import DeleteIcon from '@mui/icons-material/Delete';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import CloseIcon from '@mui/icons-material/Close';
let strCust=[{title:'',year:'0'}];

const useStyles = styled(theme => ({
 
  root: {
    width: 500,
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },

container: {  
    maxHeight: 440,  
  }, 

  table: {
    minWidth: 750,
  },
  
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
	 minWidth: 120,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  
   textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
}));

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

export default class BusinessSetting extends Component {
constructor(props) {
    super(props);
		var strdob = new Date();
var month = "";

if ((strdob.getMonth() + 1) < 10) {
    month = "0" + (strdob.getMonth() + 1);
} else {
    month = (strdob.getMonth() + 1);
}

const currentDate = new Date();

var month1 = (currentDate.getMonth() + 1 < 10) ? "0" + (currentDate.getMonth() + 1) : (currentDate.getMonth() + 1);
var lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
var lastDay = (lastDayOfMonth.getDate() < 10) ? "0" + lastDayOfMonth.getDate() : lastDayOfMonth.getDate();

	
	this.state={AcntsettingData:[],
	yearenddate: new Date(),
 yearenddate1:currentDate.getFullYear() + '-' + month1 + '-' + '01',
 
 locakdowndate: new Date(),
  locakdowndate1: currentDate.getFullYear() + '-' + month1 + '-' + '01',
	accstartdate:new Date(),
	
	accstartdate1:currentDate.getFullYear() + '-' + month1 + '-' + '01',
	submitbtn:'Save',isreasondisplay:false,erropen:false,errormessage:'',errortype:'error'
	}
 
      }
   

handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  }


componentWillMount() {
	document.title = "Isifol Account - Financial Year and Accouting Method";



 if(localStorage.getItem("ISIuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
else
{	
if(localStorage.getItem("ISIrole")==="1" || localStorage.getItem("ISIrole")==="2")
		  {
			this.GetBusinessSetting();
		  }
		  else{
	    
		this.PageAccessCheckApi();
		  }
	}
		   let strname="Financial Year and Accouting Method";
		   
	 this.props.parentdasCallback(
            strname+"~"
        ); 
		
	

} 
 
   
PageAccessCheckApi() {
	
  axios.get(localStorage.getItem("ISIurl")+'ajaxpagemaster.php?action=getbyuser&us_id='+localStorage.getItem('ISIuserid')+'&up_pm_id=23')
  
  .then(resp => {
	  
	  
	  let strreturn=resp.data;

      if (strreturn!==0) {
        	
	this.GetBusinessSetting();
      } else {
       
        this.setState({redirect: true,pagename: "/Accesspagemessage"});
      }
    
  });
}

 
  handleSubmit= (event) => {
	   event.preventDefault();
    
	let optionsVal=this.state.AcntsettingData;
	
		let optionValues="";
    let sep2="";
	
	 
	  optionsVal.forEach(eachval => {
		  
		  
		  
	 if(eachval.bs_value === "" && this.state.isreasondisplay===true)
	 {	
		 this.setState({errormessage:"Please Fill Required feilds",erropen:true,});
		 window.scrollTo({top: 0})
		 return false;
		 	 
	 }	
	 else{
		  
		 optionValues=optionValues+sep2+eachval.bs_id+"~"+eachval.bs_value;
		 sep2="`"
	 }
		   
	   });
    const formData = new FormData();
     formData.append('action','update')
	 formData.append('business',optionValues)
	 formData.append('bs_page',4)
     formData.append('bs_cmp_id',localStorage.getItem("ISIcmpid"))
     formData.append('groupmaster','')
     formData.append('userid',localStorage.getItem("ISIuserid"))
     formData.append('deletegm_id','')
    
	 
	 
	 
	 
	 	 axios.post(localStorage.getItem("ISIurl")+"ajaxbusinesssetting.php", formData, {
        }).then(res => {
			
		this.setState({btndisabled:false,submitbtn:"Save"})

			
		
   }); 
	
  };




GetBusinessSetting() {
  let strsettings = [];
  axios
    .get(localStorage.getItem("ISIurl") + 'ajaxbusinesssetting.php?action=getall&bs_page=4&bs_cmp_id='+localStorage.getItem("ISIcmpid"))
    .then(resp => {
      if (resp.data) {
		   const hasYearValue = resp.data.some(
          item => item.bs_id === "5" && item.bs_value !== ""
        );
        this.setState({
          AcntsettingData:resp.data,
		  isreasondisplay: hasYearValue, 
        }, () => {
          console.log(this.state.AcntsettingData);
        });
      } else {
        this.setState({ AcntsettingData: [] });
      }
    })
   
}




HandleCustomer= (id, rowsd) => (event) => {
  const value = event.target.value; 
  const updatedArray = [...this.state.AcntsettingData]; 

  updatedArray[rowsd].bs_value = value; 

 
  this.setState({ AcntsettingData: updatedArray }, () => {
    console.log('Updated BusiCustomerData:', this.state.AcntsettingData);
  });
};


YearEndDateHandler = (date, id, index) => {
   var month = "";
    var dateObj = new Date(date);

       if ((dateObj.getMonth() + 1) < 10) {
        month = "0" + (dateObj.getMonth() + 1);
    } else {
        month = (dateObj.getMonth() + 1);
    }

    
    this.setState({
        yearenddate: dayjs(dateObj),
        yearenddate1: dateObj.getFullYear() + '-' + month + '-' + dateObj.getDate()
    },()=>{
		
		const updatedArray = [...this.state.AcntsettingData];
    updatedArray[index].bs_value = this.state.yearenddate1;
    
    this.setState({ AcntsettingData: updatedArray }, () => {
      console.log('Updated Accounting Data:', this.state.AcntsettingData);
	});
  
    
  
  });
};

LocakDownDateHandler = (date, id, index) => {
   var month = "";
    var dateObj = new Date(date);

       if ((dateObj.getMonth() + 1) < 10) {
        month = "0" + (dateObj.getMonth() + 1);
    } else {
        month = (dateObj.getMonth() + 1);
    }

    
    this.setState({
        locakdowndate: dayjs(dateObj),
        locakdowndate1: dateObj.getFullYear() + '-' + month + '-' + dateObj.getDate()
    },()=>{
		
		const updatedArray = [...this.state.AcntsettingData];
    updatedArray[index].bs_value = this.state.locakdowndate1;
    
    this.setState({ AcntsettingData: updatedArray }, () => {
      console.log('Updated Accounting Data:', this.state.AcntsettingData);
	});
  
    
  
  });
};


AccountStartDateHandler = (date, id, index) => {
   var month = "";
    var dateObj = new Date(date);

       if ((dateObj.getMonth() + 1) < 10) {
        month = "0" + (dateObj.getMonth() + 1);
    } else {
        month = (dateObj.getMonth() + 1);
    }

    
    this.setState({
        accstartdate: dayjs(dateObj),
        accstartdate1: dateObj.getFullYear() + '-' + month + '-' + dateObj.getDate()
    },()=>{
		
		const updatedArray = [...this.state.AcntsettingData];
    updatedArray[index].bs_value = this.state.accstartdate1;
    
    this.setState({ AcntsettingData: updatedArray }, () => {
      console.log('Updated Accounting Data:', this.state.AcntsettingData);
	});
  
    
  
  });
};
myChangeHandlerPV = (id, rowsd) => (event) => {
  const value = event.target.value; 
  const name = event.target.name;

  const updatedArray = [...this.state.AcntsettingData]; 

  if (name === 'year') {
    const re = /^[0-9\.]+$/;
    if (re.test(value)) {
      updatedArray[rowsd].bs_value = value; 
    } else {
      console.warn('Only numeric values and dots are allowed for year.');
      return;
    }
  } else {
    updatedArray[rowsd].bs_value = value; 
  }

  this.setState({ AcntsettingData: updatedArray }, () => {
    console.log('Updated AcntsettingData:', this.state.AcntsettingData);
  });
};

BlureventYear = (index, gmid) => (event) => {
	 const value = event.target.value; 
  const name = event.target.name;
	if(name==='year'){
		
		if( event.target.value!=="")
		
		this.setState({isreasondisplay:true});
		
		
	}
	
	
}
  render() { 
  
  if (this.state.logredirect === true) {
      return <Navigate to={this.state.pagename} />
    }

  
  return (
 
		<React.Fragment>
	
	<p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity={this.state.errortype}
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
    
      <div className="businesssetting">
        <div className="leftpagetitle">
          <h5>ACCOUNTING DATES</h5>
          <p>
            Choose when your financial year starts and ends. Choose a ‘Lockdown’ date to stop new transactions being saved before this.
          </p>
        </div>

        <div className="pagecontentright">
		{this.state.AcntsettingData.map((item, index) => (
            <React.Fragment key={index}>
             {item.bs_id === "1" && (
			  <React.Fragment>
			   <p className="popformtextright">   
			   <b>{item.bs_title}</b>
		     </p><p className="popforminputsemail">  
		    <LocalizationProvider dateAdapter={AdapterDayjs}>
			<DemoContainer components={['DatePicker']}>
			<DatePicker
			  value={dayjs(item.bs_value)}
			  style={{ width: '50%' }}
			  onChange={(date) => this.YearEndDateHandler(date, item.bs_id, index)}
			  format="MM/DD/YYYY"
			  className="datepicker"
					/>
		  </DemoContainer>
		</LocalizationProvider>

		  </p><div className="clear"></div> 
			 </React.Fragment>
           )}
				   {item.bs_id === "2" && (
			  <React.Fragment>
			   <p className="popformtextright">   
			   <b>{item.bs_title}</b>
		     </p><p className="popforminputsemail">  
		    <LocalizationProvider dateAdapter={AdapterDayjs}>
			<DemoContainer components={['DatePicker']}>
			<DatePicker
			  value={dayjs(item.bs_value)}
			  style={{ width: '50%' }}
			  onChange={(date) => this.LocakDownDateHandler(date, item.bs_id, index)}
			  format="MM/DD/YYYY"
			   className="datepicker"
					/>
		  </DemoContainer>
		</LocalizationProvider>

		  </p><div className="clear"></div> 
			 </React.Fragment>
           )}
			 
			 
			 {item.bs_id === "3" && (
			  <React.Fragment>
			   <p className="popformtextright">   
			   <b>{item.bs_title}</b>
		     </p><p className="popforminputsemail">  
		    <LocalizationProvider dateAdapter={AdapterDayjs}>
			<DemoContainer components={['DatePicker']}>
			<DatePicker
			    value={dayjs(item.bs_value)}
			  style={{ width: '50%' }}
			  onChange={(date) => this.AccountStartDateHandler(date, item.bs_id, index)}
			  format="MM/DD/YYYY"
			  className="datepicker"
					/>
		  </DemoContainer>
		</LocalizationProvider>

		  </p><div className="clear"></div> 
			 </React.Fragment>
           )}
			 
			 
			 
            </React.Fragment>
          ))}
        </div>

        <div className="clear"></div>
      </div>



 <div className="businesssetting">
        <div className="leftpagetitle">
          <h5>BUSINESS DATA RETENTION PERIOD</h5>
          <p>
            Choose how long you need to keep your accounting records. We’ll use this to calculate how long you should keep your contact’s personal data. This is important for complying with data protection laws.

          </p>
        </div>

        <div className="pagecontentright">
		{this.state.AcntsettingData.map((item, index) => (
            <React.Fragment key={index}>
             {item.bs_id === "4" && (
			  <React.Fragment>
			   <p className="popformtextright">   
			   <b>{item.bs_title} <span className="validation">*</span></b>
		     </p><p className="popforminputsemail">  
		    
              <Select
				 native
				 variant="outlined" className="txtbox"
				  margin="normal"
				  id="bs_value"
				 value={item.bs_value}
				 onChange={this.myChangeHandlerPV(item.bs_id, index)}
				 
				inputProps={{tabIndex: "4"}}
				 className="txtbox"
			    style={{ width: '39%' }} 
				>
	      <option value={0}>Select</option>
	      <option value={1}>January</option>
	       <option value={2}>February</option>	
	       <option value={3}>March</option>	
	       <option value={4}>April </option>	
	       <option value={5}>May </option>	
	       <option value={6}>June</option>	
	       <option value={7}>July</option>	
	       <option value={8}>August</option>	
	       <option value={9}>September</option>	
	       <option value={10}>October</option>	
	       <option value={11}>November</option>	
	       <option value={12}>December</option>	
          </Select>

		  </p><div className="clear"></div> 
			 </React.Fragment>
           )}
		   
			{item.bs_id === "5" && (
			  <React.Fragment>
			   <p className="popformtextright">   
			   <b>{item.bs_title}</b>
		       </p><p className="popforminputsemail">  
		       <TextField
             
             onChange={this.myChangeHandlerPV(item.bs_id, index)}
			
              fullWidth
              value={item.bs_value}  
              ref={this.usernameInput}
              inputProps={{ tabIndex: '1', maxLength: 150 }}
              className="txtbox"
			  name="year"
			    style={{ width: '15%' }} 
				onBlur={this.BlureventYear(item.bs_id, index)}
              InputLabelProps={{ shrink: true }}
            />&nbsp;<b> Years(s)</b>
                     
		       </p><div className="clear"></div> 
			   </React.Fragment>
            )}
			 
			 
			 {item.bs_id === "6" && this.state.isreasondisplay===true && (
			  <React.Fragment>
			   <p className="popformtextright">   
			   <b>{item.bs_title} <span className="validation">*</span></b>
		       </p><p className="popforminputsemail">  
		       <TextField
             
             onChange={this.myChangeHandlerPV(item.bs_id, index)}
			
              fullWidth
              value={item.bs_value}  
              ref={this.usernameInput}
              inputProps={{ tabIndex: '1', maxLength: 150 }}
              className="txtbox"
			  name="reason"
			  multiline rows={1}
			  style={{width:'39%'}}
			  
              InputLabelProps={{ shrink: true }}
            />
                     
		       </p><div className="clear"></div> 
			   </React.Fragment>
            )}
			 
			 
            </React.Fragment>
          ))}
        </div>

        <div className="clear"></div>
      </div>





<p className="aligncentr"> 
	 <Button variant="contained" className="frmSecondarybtn" onClick={this.handleSubmit}>
   {this.state.submitbtn}
</Button></p>
		 

 </React.Fragment>
  );
  }
}